module.exports = __webpack_public_path__ + "img/Ele4.a8be847d.jpg";